import React, { type ComponentProps, type PropsWithChildren } from 'react';

import type { StyledComponent } from '@emotion/styled';
import styled from '@mui/material/styles/styled';

interface IButtonBladeProps extends PropsWithChildren<ComponentProps<'div'>> {}

interface IEndcapProps extends ComponentProps<'svg'> {
  orientation: 'start' | 'end';
}

const Endcap = styled(({ className }: IEndcapProps) => (
  <svg viewBox="0 0 55 40" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
    <g>
      <path
        d="M55 40L44.0711 40C41.4156 40 38.8692 38.9438 36.9933 37.0643L3.49691e-06 -4.80825e-06L55 0L55 40Z"
        fill="currentColor"
      />
    </g>
  </svg>
))<IEndcapProps>(({ orientation }) => ({
  height: 4,
  width: 6.2,
  transformOrigin: '50% 50%',
  transform: `scale(${orientation === 'start' ? 1 : -1}, -1) translateX(1px)`
}));

export const ButtonBlade: StyledComponent<IButtonBladeProps> = styled(
  ({ className }: IButtonBladeProps) => (
    <div className={`button-blade ${className}`}>
      <Endcap orientation="start" />

      <div className="button-blade-bar" />

      <Endcap orientation="end" />
    </div>
  )
)({
  position: 'absolute',
  bottom: 0,
  left: 'calc(-1 * var(--button-blade-scale, 1px))',
  right: 'calc(-1 * var(--button-blade-scale, 1px))',

  display: 'flex',

  height: 4,
  transform: 'translateY(0.5px)',
  transition: 'all 125ms ease-in-out',

  color: 'var(--button-blade-color)',

  '& .button-blade-bar': {
    width: '100%',
    height: 4,
    backgroundColor: 'var(--button-blade-color)',
    transition: 'all 125ms ease-in-out'
  }
});
